/**
 * Lightweight email validation. Stricter than Zod's, allows display name with angle brackets.
 */
const SIMPLE_EMAIL = /^[^\s@<>"]+@[^\s@<>"]+\.[^\s@<>"]+$/;
export function isValidEmail(value: string): boolean {
  return SIMPLE_EMAIL.test(value.trim());
}
